import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { Box } from '@mantine/core';
import queryString from 'query-string';
import { useParams } from 'react-router';
import segmentPresets from '../../constants/segmentPresets';
import useFetch from '../../helpers/useFetch';
import useCrossDomainCopyPage from '../../hooks/useCrossDomainCopyPage';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import SegmentForm from './SegmentForm';

const SegmentNewForm = ({ onSave, onBack, disabledScopes = [] }) => {
  const fetch = useFetch();
  const location = useLocation();

  const { from, fromDomain } = useCrossDomainCopyPage();

  const [segment, setSegment] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    const query = queryString.parse(location.search);
    const isNotCampaignPage =
      !location.pathname.endsWith('campaigns/new') && !location.pathname.endsWith('workflows/new');

    if (isNotCampaignPage && (query.fromSegment || from)) {
      // Handle both old 'fromSegment' parameter and new 'from' parameter for consistency
      const segmentId = query.fromSegment || from;
      // Use fromDomain if provided (cross-domain copy), otherwise use current domainId (same domain copy)

      fetch(`/api/admin/accounts/${accountId}/domains/${fromDomain || domainId}/segments/${segmentId}`)
        .then(({ segment }) => {
          delete segment.id;
          delete segment.externalId;
          segment.lastCalculatedAt = null;
          segment.lastCalculatedCount = null;
          segment.lastCalculatedSegmentRunId = null;
          segment.lastRunAt = null;
          segment.nextSegmentRunId = null;

          if (!fromDomain) {
            segment.name = `Copy of ${segment.name}`;
          }
          setSegment(segment);
        })
        .catch(setLoadError);
    } else {
      let rules = [];
      if (query.preset) {
        rules = segmentPresets(query) || [];
      }

      setSegment({
        name: 'New segment',
        rules,
        scope: 'behavior',
        externalScope: null,
      });
    }
  }, [accountId, domainId, fetch, location.search, location.pathname, from, fromDomain]);

  const create = (segment) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments`, {
      method: 'POST',
      body: JSON.stringify(segment),
    })
      .then(({ segment }) => {
        onSave(segment);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!segment) {
    return <Spinner />;
  }

  return (
    <>
      <SegmentForm
        segment={segment}
        saveSegment={(segment) => create(segment)}
        onBack={onBack}
        disabledScopes={disabledScopes}
      />
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default SegmentNewForm;
